import {Component} from "@angular/core";
import {ClientProfileService, TenantService} from "../../_services";
import {OidcService} from "../../_services/oidc.service";
import {LoginHelper} from "../../helpers";

@Component({
    standalone: false,
  selector: 'oidc-callback',
  template: ''
})
export class OidcCallbackComponent {
  constructor(
    public tenantService: TenantService,
    public clientProfileService: ClientProfileService,
    public oidcService: OidcService
  ) {
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantNameFromUrl();
    this.clientProfileService.getPublicSettings(tenantName).subscribe(settings => {
      this.oidcService.getUserManager(settings, tenantName).signinPopupCallback()
    })
  }
}
